import { render, staticRenderFns } from "./studyVideo.vue?vue&type=template&id=26ec946a&scoped=true"
import script from "./studyVideo.vue?vue&type=script&lang=js"
export * from "./studyVideo.vue?vue&type=script&lang=js"
import style0 from "./studyVideo.vue?vue&type=style&index=0&id=26ec946a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ec946a",
  null
  
)

export default component.exports